import { RxSocketUrls } from '@Constants/CommonConstants';

export const HEADER_NAME_TOKEN = 'rs_token';
export const HEADER_NAME_ORIGIN = 'rs_origin';
export const SOCKET_ENDPOINTS = [RxSocketUrls.QuickSearchUrl, RxSocketUrls.AdvancedQuery, RxSocketUrls.ResultsUrl];
